export default __webpack_public_path__ + "static/Menina-e-gato-4cd03ad656fe4bbbd42c9e347680f6ad.jpg";